import Cookies from "js-cookie";

import { CookieList } from "@utils/enums";

class EcornerService {
    static getEcornerCookie(): string | undefined {
        return Cookies.get(CookieList.ECORDER_ID);
    }

    static isEcornerEnvironment(): boolean {
        return !!EcornerService.getEcornerCookie();
    }
}

export { EcornerService };
